import { cur } from '@/lib/currency';

function fmt(n) {
  return Number(n || 0).toLocaleString('ar-EG', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

const BUCKETS = [
  { key: 'current', label: 'غير مستحق', color: 'bg-emerald-500', textColor: 'text-emerald-700', light: 'bg-emerald-50' },
  { key: 'b30', label: '1-30 يوم', color: 'bg-amber-400', textColor: 'text-amber-700', light: 'bg-amber-50' },
  { key: 'b60', label: '31-60 يوم', color: 'bg-orange-500', textColor: 'text-orange-700', light: 'bg-orange-50' },
  { key: 'b90', label: '61-90 يوم', color: 'bg-red-400', textColor: 'text-red-700', light: 'bg-red-50' },
  { key: 'b90plus', label: '90+ يوم', color: 'bg-red-700', textColor: 'text-red-900', light: 'bg-red-100' },
];

export default function ArAgingWidget({ aging, onBucketClick }) {
  if (!aging) return (
    <div className="bg-card border border-border rounded-2xl p-4 h-24 animate-pulse" />
  );

  // Defensive: backend may return different shapes (or null fields)
  const buckets = aging.buckets || {};
  const counts = aging.counts || {};
  const total = Number(aging.total) || 0;

  // If everything is empty, show a friendly empty state instead of an
  // empty bar (which used to crash when buckets was undefined).
  const hasAny = total > 0 || BUCKETS.some(b => buckets[b.key]);
  if (!hasAny) {
    return (
      <div className="bg-card border border-border rounded-2xl p-4">
        <div className="flex items-center justify-between mb-2">
          <p className="text-sm font-bold text-foreground">تحليل الديون (Aging)</p>
          <p className="text-sm font-bold text-emerald-600">0 {cur()}</p>
        </div>
        <p className="text-xs text-muted-foreground text-center py-2">
          🎉 لا توجد مستحقات
        </p>
      </div>
    );
  }

  const safeTotal = total || 1;

  return (
    <div className="bg-card border border-border rounded-2xl p-4 space-y-3">
      <div className="flex items-center justify-between">
        <p className="text-sm font-bold text-foreground">تحليل الديون (Aging)</p>
        <p className="text-sm font-bold text-primary">{fmt(total)} {cur()}</p>
      </div>

      {/* Stacked bar */}
      <div className="flex h-5 rounded-full overflow-hidden gap-0.5">
        {BUCKETS.map(b => {
          const amt = Number(buckets[b.key]) || 0;
          const pct = amt > 0 ? (amt / safeTotal) * 100 : 0;
          if (pct < 1) return null;
          return (
            <div key={b.key} className={`${b.color} cursor-pointer transition-all hover:opacity-80`}
              style={{ width: `${pct}%` }}
              onClick={() => onBucketClick?.(b.key)} />
          );
        })}
      </div>

      {/* Legend */}
      <div className="grid grid-cols-2 gap-1.5">
        {BUCKETS.map(b => {
          const amt = Number(buckets[b.key]) || 0;
          const cnt = Number(counts[b.key]) || 0;
          const pct = safeTotal > 0 ? Math.round((amt / safeTotal) * 100) : 0;
          if (!amt) return null;
          return (
            <div key={b.key} onClick={() => onBucketClick?.(b.key)}
              className={`${b.light} rounded-xl p-2 cursor-pointer hover:opacity-80 transition-all`}>
              <div className="flex items-center gap-1.5 mb-0.5">
                <div className={`w-2 h-2 rounded-full ${b.color}`} />
                <p className={`text-xs font-semibold ${b.textColor}`}>{b.label}</p>
                <span className="text-xs text-muted-foreground mr-auto">{pct}%</span>
              </div>
              <p className={`text-sm font-bold ${b.textColor}`}>{fmt(amt)} {cur()}</p>
              <p className="text-xs text-muted-foreground">{cnt} فاتورة</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}